import { Button, Menu, Typography, MenuItem } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { useState } from "react";

// Icons
import AddTwoToneIcon from "@mui/icons-material/AddTwoTone";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import PublicIcon from "@mui/icons-material/Public";
import SickIcon from "@mui/icons-material/SickOutlined";
import BusinessIcon from "@mui/icons-material/Business";
import SchoolIcon from "@mui/icons-material/School";

// Constants
import {
    EVENT_VACATION,
    EVENT_SICK_LEAVE,
    EVENT_PUBLIC_HOLIDAY,
    EVENT_COMPANY_HOLIDAY,
    EVENT_EDUCATIONAL_LEAVE
} from "@/helpers/constants";

const MENU_ITEMS = [
    {
        id: EVENT_VACATION,
        icon: <ConnectWithoutContactIcon fontSize="small" sx={{ mr: 0.75 }} />,
        label: "create-vacation",
        testid: "create-substitute"
    },
    {
        id: EVENT_SICK_LEAVE,
        icon: <SickIcon fontSize="small" sx={{ mr: 0.75 }} />,
        label: "create-sick-leave",
        testid: "create-sick-leave"
    },

    {
        id: EVENT_PUBLIC_HOLIDAY,
        icon: <PublicIcon fontSize="small" sx={{ mr: 0.75 }} />,
        label: "create-public-holiday",
        testid: "create-public-holiday"
    },
    {
        id: EVENT_COMPANY_HOLIDAY,
        icon: <BusinessIcon fontSize="small" sx={{ mr: 0.75 }} />,
        label: "create-company-holiday",
        testid: "create-company-holiday"
    },
    {
        id: EVENT_EDUCATIONAL_LEAVE,
        icon: <SchoolIcon fontSize="small" sx={{ mr: 0.75 }} />,
        label: "create-educational-leave",
        testid: "create-educational-leave"
    }
];

type MenuItemType =
    | typeof EVENT_VACATION
    | typeof EVENT_SICK_LEAVE
    | typeof EVENT_PUBLIC_HOLIDAY
    | typeof EVENT_COMPANY_HOLIDAY
    | typeof EVENT_EDUCATIONAL_LEAVE;

export const CalendarCreateButton = ({ onMenuItemClick }: { onMenuItemClick: (type: MenuItemType) => void }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleCreateMenuClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCreateMenuClose = () => {
        setAnchorEl(null);
    };

    const handleOnMenuItemClick = (event: React.MouseEvent<HTMLElement>) => {
        handleCreateMenuClose();
        onMenuItemClick(event.currentTarget.id as MenuItemType);
    };

    return (
        <div>
            <Button
                color="secondary"
                variant="contained"
                onClick={handleCreateMenuClick}
                endIcon={<ArrowDropDownIcon />}
                data-testid="open-create-menu"
                startIcon={<AddTwoToneIcon fontSize="medium" />}
                sx={{
                    fontSize: "15px",
                    padding: "15px 18px",
                    borderRadius: "16px",
                    "&:hover": { backgroundColor: "#c51d34d9" }
                }}
            >
                <FormattedMessage id="create" />
            </Button>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCreateMenuClose}>
                {MENU_ITEMS.map(item => (
                    <MenuItem
                        key={item.id}
                        id={item.id}
                        onClick={handleOnMenuItemClick}
                        data-testid={item.id}
                        sx={{ padding: "14px 16px" }}
                    >
                        {item.icon}

                        <Typography fontSize="15px">
                            <FormattedMessage id={item.label} />
                        </Typography>
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
};
